import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Mouse, ArrowRight } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function PrestigeVisionHero() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll();
  return <section id="prestige-vision-hero" className="relative h-screen min-h-[800px] w-full overflow-hidden dark bg-background text-foreground">
      {}
      <div className="absolute inset-0 z-0">
        <video autoPlay muted loop playsInline className="h-full w-full object-cover">
          <source media="(max-width: 767px)" src="https://coastalprestigemowing.com.au/wp-content/uploads/2026/04/Phone-Hero-Video.mp4" />
          <source src="https://coastalprestigemowing.com.au/wp-content/uploads/2026/04/Coastal-Prestige-Mowing-Hero.mp4" />
        </video>
        
        {}
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(0,0,0,0.1)_0%,rgba(0,0,0,0.4)_100%)] z-10" />
        
        {}
        <div className="absolute inset-0 bg-black/20 z-10" />
      </div>

      {}
      <div className="relative z-20 flex h-full flex-col items-center justify-center px-4 text-center sm:px-6 lg:px-8">
        
      </div>

      {}
      <div className="absolute bottom-12 left-1/2 z-20 -translate-x-1/2 animate-bounce">
        <div className="flex flex-col items-center gap-2 opacity-80">
          <span className="text-xs font-medium uppercase tracking-widest text-white/70">
            Scroll
          </span>
          <Mouse className="h-8 w-8 text-primary" />
        </div>
      </div>

      {}
      <div className="absolute bottom-0 left-0 z-10 h-32 w-full bg-gradient-to-b from-transparent to-background" />
    </section>;
}